import { PropsWithChildren } from 'react'
import { cn } from 'ui/lib/utils'

type MobileBottomLayoutProps = PropsWithChildren<{
  className?: string
}>

export const MobileBottomLayout = ({ children, className }: MobileBottomLayoutProps) => (
  <div className="flex h-full justify-center gap-4 pb-1">
    <section className={cn('flex h-full w-full max-w-md grow flex-col justify-end gap-4 md:justify-center', className)}>
      {children}
    </section>
  </div>
)
